@if (story()) {
  <div class="fm-story-detail fm-layout-space">
    <div class="container-fluid">
      <!-- Back Button -->
      <button type="button" class="fm-back-btn mb-4" (click)="goBack()">
        <i class="bi bi-arrow-left"></i> Back to Stories
      </button>

      <div class="row g-4">
        <!-- Main Content -->
        <div class="col-lg-8">
          <!-- Video Player -->
          <div class="fm-video-player mb-4">
            <div class="fm-video-wrapper position-relative">
              <img [src]="story()!.coverImage" class="img-fluid w-100 fm-video-poster" [alt]="story()!.title"
                onerror="this.src='images/stories/placeholder.png'" />
              <button class="fm-video-play-btn" (click)="togglePlay()">
                <i [class]="isPlaying() ? 'bi bi-pause-fill' : 'bi bi-play-fill'"></i>
              </button>
              <span class="fm-duration-tag">{{ story()!.duration }}</span>
            </div>
          </div>

          <!-- Story Info -->
          <div class="fm-story-info mb-3">
            <span class="fm-category-tag">{{ story()!.category }}</span>
            <span class="text-muted ms-3 small">{{ story()!.date }}</span>
          </div>
          <h2 class="fm-head-32 fw-bold mb-3">{{ story()!.title }}</h2>

          <!-- Author -->
          <div class="fm-userprofile mb-4">
            <div class="fm-userprofile-image">
              <img class="fm-profile" [src]="story()!.authorAvatar" [alt]="story()!.authorName"
                onerror="this.src='images/user-placeholder.png'" />
            </div>
            <span class="fm-profile-content">
              <p class="mb-0">{{ story()!.authorName }}</p>
              <small class="text-muted"><i class="bi bi-people"></i> {{ story()!.familyGroup }}</small>
            </span>
          </div>

          <!-- Reactions -->
          <div class="fm-reactions d-flex align-items-center gap-3 mb-4">
            <button type="button" class="fm-react-btn" [class.active]="isLiked()" (click)="toggleLike()">
              <i [class]="isLiked() ? 'bi bi-heart-fill' : 'bi bi-heart'"></i>
              {{ story()!.hearts + (isLiked() ? 1 : 0) }}
            </button>
            <button type="button" class="fm-react-btn">
              <i class="bi bi-emoji-smile"></i> React
            </button>
            <span class="text-muted small ms-auto"><i class="bi bi-eye"></i> {{ story()!.views }} views</span>
          </div>

          <!-- Transcript -->
          <div class="fm-transcript-section">
            <button type="button" class="fm-transcript-toggle d-flex align-items-center justify-content-between w-100"
              (click)="toggleTranscript()">
              <span class="fw-bold">Full Transcript</span>
              <i [class]="transcriptOpen() ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
            </button>
            @if (transcriptOpen()) {
              <div class="fm-transcript-body mt-3">
                <p>{{ story()!.transcript }}</p>
              </div>
            }
          </div>
        </div>

        <!-- Right Sidebar -->
        <div class="col-lg-4">
          <div class="fm-story-actions d-flex flex-column gap-3">
            <button type="button" class="fm-common-btn w-100">
              <i class="bi bi-share me-2"></i>Share Story
            </button>
            <button type="button" class="fm-common-btn fm-border-btn w-100">
              <i class="bi bi-download me-2"></i>Download
            </button>
            <button type="button" class="fm-common-btn fm-outline-danger-btn w-100">
              <i class="bi bi-flag me-2"></i>Report Story
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="d-flex align-items-center justify-content-center" style="min-height:300px;">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
}
